<template>
  <div class="ibox">
    <div class="ibox-title"><h5>价格设置</h5></div>
    <div class="ibox-content">
    <div class="crud-bar">
      <el-button type="primary" :loading="saving" @click="onSave">保存改价</el-button>
      <span class="tip">仅可售条目可改价，分组标题不可改。</span>
    </div>
    <el-table :data="rows" v-loading="loading" border stripe row-key="id" default-expand-all :tree-props="{ children: 'children' }">
      <el-table-column prop="name" label="名称" />
      <el-table-column prop="subname" label="类型" width="140" />
      <el-table-column prop="type" label="标识" width="140" />
      <el-table-column label="价格(元)" width="200">
        <template slot-scope="s">
          <el-input-number v-if="!s.row.isParent" v-model="s.row.price" :min="0" :precision="2" :step="1" size="small" />
          <span v-else>—</span>
        </template>
      </el-table-column>
    </el-table>
    </div>
  </div>
</template>

<script>
import { pricesApi } from '../api/business'

export default {
  name: 'AdminPrices',
  data () {
    return {
      loading: false,
      saving: false,
      rows: [],
      parentMap: {}
    }
  },
  created () { this.fetch() },
  methods: {
    async fetch () {
      this.loading = true
      try {
        const data = await pricesApi.list()
        const parents = data.parents || []
        const sellable = data.sellable || []
        const map = {}
        parents.forEach(p => { map[p.id] = { ...p, isParent: true, children: [] } })
        // 后端 Configprice 的父级 id 字段带 @JsonProperty("p_id")，接口里是 p_id 不是 pId。
        // 之前写 s.pId 恒为 undefined，可售条目全都挂不进分组、落到 else 分支，
        // 而它们 push 进的 this.rows 紧接着又被 Object.values(map) 整体覆盖，
        // 结果表格只剩分组标题行（价格列显示 "—"），看不到任何价格。
        // 同时把没有父级的卖品（会员、日课等 p_id=0 的条目）单独收集，避免被覆盖丢失。
        const roots = []
        sellable.forEach(s => {
          const row = { ...s, isParent: false }
          const pid = Number(s.p_id || 0)
          if (pid > 0 && map[pid]) map[pid].children.push(row)
          else roots.push(row)
        })
        this.rows = roots.concat(Object.values(map))
      } catch (e) {
        this.$message.error(e.uiMessage || e.message)
      } finally {
        this.loading = false
      }
    },
    async onSave () {
      const items = []
      const walk = (list) => list.forEach(r => {
        if (!r.isParent) items.push({ id: r.id, price: r.price })
        if (r.children) walk(r.children)
      })
      walk(this.rows)
      if (!items.length) return this.$message.warning('无可保存项')
      this.saving = true
      try {
        await pricesApi.save(items)
        this.$message.success('价格已更新')
      } catch (e) {
        this.$message.error(e.uiMessage || e.message)
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.crud-bar { margin-bottom: 16px; display: flex; align-items: center; gap: 12px; }
.tip { color: #909399; font-size: 13px; }
</style>
